import React, { useRef } from 'react';
import { exchangeDate } from "../../helpers";
import Spacing from '../Spacing';
import { Drawer } from 'vaul';

export default function AppointmentSingleViewModal(props) {
  const {
    practice_data = {},
    activeModal,
    setActiveModal = () => {},
    previousScrollPosition = 0,
  } = props;
  
  const dropdownRef = useRef(null);

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Add Patient</Drawer.Title>
            <Drawer.Description className="sr-only">Add a new patient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">
              <div className="docpro_modal">
                <div style={{ height: '95%' }}>
                  <h2 className="docpro_fs_24 docpro_mb_0 text-center">Appointment Details</h2>
                  <Spacing lg="30" sm="30" />

                  <div className="docpro_table_responsive docpro_table_1 hipaa_table" style={{ boxShadow: 'none' }}>
                    <table className="docpro_mb_0" style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width:'180px', borderTop: 0 }}><b>Location</b></td>
                          <td colSpan={3} style={{ borderTop: 0 }}>{practice_data?.location?.name}</td>
                        </tr>
                        <tr>
                          <td><b>Patient name</b></td>
                          <td style={{ borderRight: '1px solid var(--border)' }}>{practice_data?.last_name} {practice_data?.first_name}</td>
                          <td style={{ width:'160px' }}><b>Date of birth</b></td>
                          <td>{exchangeDate(practice_data?.dob)}</td>
                        </tr>
                        <tr>
                          <td><b>Gender</b></td>
                          <td style={{ borderRight: '1px solid var(--border)' }}>{practice_data?.gender}</td>
                          <td><b>Phone</b></td>
                          <td>{practice_data?.phoneNumber}</td>
                        </tr>
                        <tr>
                          <td style={{ verticalAlign: 'top' }}><b>Patient type</b></td>
                          <td style={{ borderRight: '1px solid var(--border)' }}>{practice_data?.patient_type === true ? 'New Patient' : 'Existing Patient'}</td>
                          <td style={{ verticalAlign: 'top' }}><b>Email</b></td>
                          <td>{practice_data?.email}</td>
                        </tr>
                        <tr>
                          <td style={{ verticalAlign: 'top' }}><b>Insurance name</b></td>
                          <td style={{ borderRight: '1px solid var(--border)' }}>{practice_data?.insurance_name}</td>
                          <td style={{ verticalAlign: 'top' }}><b>Insurance ID</b></td>
                          <td>{practice_data?.insurance_id}</td>
                        </tr>
                        <tr>
                          <td><b>Preferred Date</b></td>
                          <td style={{ borderRight: '1px solid var(--border)' }}>{exchangeDate(practice_data?.preferred_date_1)}</td>
                          <td><b>Preferred Date 2</b></td>
                          <td>{exchangeDate(practice_data?.preferred_date_2)}</td>
                        </tr>
                        <tr>
                          <td><b>Preferred Time of Day</b></td>
                          <td colSpan={3}>{practice_data?.appointment_time}</td>
                        </tr>
                        <tr>
                          <td><b>Status</b></td>
                          <td colSpan={3}>
                            {practice_data?.status === "expired" && (
                              <span className='docpro_orange_color'>Expired</span>
                            )}
                            {practice_data?.status === "cancelled" && (
                              <span className='docpro_red_color'>Cancelled</span>
                            )}
                            {practice_data?.status === "confirmed" && (
                              <span className='docpro_green_color'>Confirmed</span>
                            )}
                            {practice_data?.status === "rescheduled" && (
                              <span className='docpro_purple_color'>Rescheduled</span>
                            )}
                            {practice_data?.status === "pending" && (
                              <span className='docpro_orange_color'>Pending</span>
                            )}
                            {practice_data?.status === "completed" && (
                              <span className='docpro_green_color'>Completed</span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ verticalAlign: 'top' }}><b>Chronic conditions</b></td>
                          <td colSpan={3}>{practice_data?.chronic_conditions?.join(", ")}</td>
                        </tr>
                        <tr>
                          <td style={{ verticalAlign: 'top' }}><b>Reason for visit</b></td>
                          <td colSpan={3}>{practice_data?.reason_for_visit}</td>
                        </tr>
                        <tr>
                          <td style={{ verticalAlign: 'top' }}><b>Comments</b></td>
                          <td colSpan={3}>{practice_data?.comment}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <Spacing lg="50" sm="50" />
                </div>
                <div className="docpro_modal_btns" style={{ marginTop: 'auto' }}>
                  <button
                    className="docpro_bordered_btn docpro_fw_600 size_lg"
                    onClick={(e) => {handleDrawerClose();}}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}